import { Routes } from '@angular/router';

import { authGuard } from './core/guards/auth.guard';
import { adminRoleGuard } from './core/guards/admin-role.guard';
import { activeClientParamGuard } from './core/guards/active-client-param.guard';
import { staffOnlyGuard } from './core/guards/staff-only.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/containers/login-page/login-page.component').then(
        (m) => m.LoginPageComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./features/auth/containers/forgot-password-page/forgot-password-page.component').then(
        (m) => m.ForgotPasswordPageComponent,
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/containers/reset-password-page/reset-password-page.component').then(
        (m) => m.ResetPasswordPageComponent,
      ),
  },
  {
    path: 'public-quote-forms/:formId',
    loadComponent: () =>
      import('./features/quote-forms/containers/public-quote-form-page/public-quote-form-page.component').then(
        (m) => m.PublicQuoteFormPageComponent,
      ),
  },
  {
    path: 'terms',
    loadComponent: () =>
      import('./features/legal/containers/terms-page/terms-page.component').then(
        (m) => m.TermsPageComponent,
      ),
  },
  {
    path: 'privacy',
    loadComponent: () =>
      import('./features/legal/containers/privacy-page/privacy-page.component').then(
        (m) => m.PrivacyPageComponent,
      ),
  },
  {
    path: 'sms-consent',
    loadComponent: () =>
      import('./features/legal/containers/sms-consent-page/sms-consent-page.component').then(
        (m) => m.SmsConsentPageComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    canActivate: [authGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'client-view',
        loadChildren: () =>
          import('./features/client-view/client-view.routes').then((m) => m.default),
      },
      {
        path: 'home',
        canActivate: [staffOnlyGuard],
        loadComponent: () =>
          import('./features/home/containers/home-page/home-page.component').then(
            (m) => m.HomePageComponent,
          ),
        data: { initialTab: 'communication' as const },
      },
      {
        path: 'pipeline',
        canActivate: [staffOnlyGuard],
        loadChildren: () =>
          import('./features/pipeline/pipeline.routes').then((m) => m.default),
      },
      { path: 'communication', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'quote-forms',
        canActivate: [staffOnlyGuard],
        loadChildren: () =>
          import('./features/quote-forms/quote-forms.routes').then((m) => m.default),
      },
      {
        path: 'configuration',
        canActivate: [staffOnlyGuard],
        loadComponent: () =>
          import('./features/configuration/containers/configuration-page/configuration-page.component').then(
            (m) => m.ConfigurationPageComponent,
          ),
        data: { initialTab: 'clients' as const },
      },
      {
        path: 'clients',
        canActivate: [staffOnlyGuard],
        loadChildren: () =>
          import('./features/clients/clients.routes').then((m) => m.default),
      },
      {
        path: 'users',
        canActivate: [adminRoleGuard],
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.default),
      },
      {
        path: 'audit-logs',
        canActivate: [adminRoleGuard],
        loadChildren: () =>
          import('./features/audit-logs/audit-logs.routes').then((m) => m.default),
      },
      { path: 'pricing', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'clients/:clientId',
        canActivate: [staffOnlyGuard, activeClientParamGuard],
        loadChildren: () =>
          import('./features/catalog-pricing/catalog-pricing.routes').then((m) => m.default),
      },
      { path: '**', redirectTo: 'home' },
    ],
  },
  { path: '**', redirectTo: 'login' },
];
